import { useState } from "react";

import { RiFileExcel2Fill } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";

import { timeToString } from "@/utils/dateUtil";
import { MedicalAttendanceTypeEnum } from "@/utils/enums/MedicalAttendanceTypeEnum";
import { exportExcel } from "@/utils/exports";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { GenericObject } from "@/@types/generics/genericals";
import { User } from "@/@types/sintegrada/User";

import { BaseModalProps } from "@/components/BaseModal";
import { NonSpecializedMedicalAttendanceDashboardData } from "@/services/sintegrada/attendance/getNonSpecializedMedicalAttendanceDashboard";
import { AttendanceByProfessionalTable } from "../AttendanceByProfessionalTable";

type Props = BaseModalProps & {
	dashboardData: NonSpecializedMedicalAttendanceDashboardData;
};

export function AttendanceByProfessionalModal({ dashboardData, ...rest }: Props) {
	const [isLoadingExportExcel, setIsLoadingExportExcel] = useState(false);

	function handleExportTable() {
		setIsLoadingExportExcel(true);
		if (
			Object.keys(dashboardData.aggregatedByProfessionalsAndMedicalAttendanceType || [])
				.length
		) {
			const excelData: GenericObject[] = transformPregnantPatientsToExportExcel(
				dashboardData.aggregatedByProfessionalsAndMedicalAttendanceType
			);
			exportExcel(excelData, `Tabela`);
		}
		setIsLoadingExportExcel(false);
	}

	function transformPregnantPatientsToExportExcel(
		professionalGroups: ResumeGrouped<User, ResumeGrouped<MedicalAttendanceTypeEnum, object>>[]
	) {
		return professionalGroups.map(
			(professionalGroup) =>
				({
					Profissional: professionalGroup.key.name ?? "N/A",
					Consultas:
						(professionalGroup.values || []).find(
							(attendanceTypeGroup) =>
								attendanceTypeGroup.key === MedicalAttendanceTypeEnum.REQUESTED
						)?.total || 0,
					Reavaliações:
						(professionalGroup.values || []).find(
							(attendanceTypeGroup) =>
								attendanceTypeGroup.key === MedicalAttendanceTypeEnum.EVALUATED
						)?.total || 0,
					"Tempo médio de atendimento": timeToString(
						dashboardData.averageTimeInSecondsByProfessional.find(
							(a) => a.key.id === professionalGroup.key.id
						)?.total || 0
					),
					Total: (professionalGroup.values || [])
						.map((attendanceTypeGroup) => attendanceTypeGroup.total)
						.reduce((acc, curr) => acc + curr, 0),
				} as GenericObject)
		);
	}
	return (
		<Modal size="xl" scrollable {...rest}>
			<Modal.Header className="d-flex justify-content-between" closeButton>
				<Modal.Title>Atendimentos por profissional</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row className="d-flex justify-content-end">
					<Col sm={2} md={2} lg={2} xl={2} className="d-flex justify-content-end">
						<Button
							className="justify-content-end"
							variant="secondary"
							onClick={handleExportTable}
							disabled={isLoadingExportExcel}
						>
							<RiFileExcel2Fill />
							Exportar
						</Button>
					</Col>
				</Row>
				<Row className="p-2">
					<AttendanceByProfessionalTable
						aggregatedByProfessionalsAndMedicalAttendanceType={
							dashboardData.aggregatedByProfessionalsAndMedicalAttendanceType
						}
						averageTimeInSecondsByProfessional={
							dashboardData.averageTimeInSecondsByProfessional
						}
					/>
				</Row>
			</Modal.Body>
		</Modal>
	);
}
